import React, { useState } from "react";
import { Megaphone, Loader2, Trash2 } from "lucide-react";
import { postCustomerUpdate, deleteCustomerUpdate } from "../../lib/api";
import { toast } from "../../hooks/use-toast";

const input = "w-full bg-navy-700 border border-white/15 focus:border-gold rounded-lg px-3 py-2 text-white text-sm placeholder-slate-500 outline-none transition-colors";

const OrderUpdates = ({ order, onChange }) => {
  const [msg, setMsg] = useState("");
  const [notify, setNotify] = useState(true);
  const [busy, setBusy] = useState(false);
  const ups = order.customerUpdates || [];

  const post = async () => {
    if (!msg.trim()) return;
    setBusy(true);
    try {
      await postCustomerUpdate(order.id, msg, notify && !!order.customer?.email);
      setMsg("");
      toast({ title: "Update posted", description: notify ? "Customer will get an email to check the Track page." : "Visible on the Track page." });
      onChange();
    } catch (e) { toast({ title: "Error", description: e?.response?.data?.detail || "Could not post update." }); }
    finally { setBusy(false); }
  };

  const remove = async (i) => { await deleteCustomerUpdate(order.id, i); onChange(); };

  return (
    <div className="mt-5 border-t border-white/10 pt-4" data-testid={`order-updates-${order.orderId}`}>
      <p className="text-white font-semibold mb-1 inline-flex items-center gap-2"><Megaphone size={15} className="text-gold" /> Customer Updates</p>
      <p className="text-slate-500 text-xs mb-3">Shown to the customer on the Track Order page.</p>
      {ups.length > 0 && (
        <div className="space-y-2 mb-3">
          {ups.map((u, i) => (
            <div key={i} className="flex items-start justify-between gap-3 bg-navy-700/60 rounded-lg px-3 py-2">
              <div><p className="text-slate-200 text-sm whitespace-pre-wrap">{u.message}</p><p className="text-slate-500 text-[11px]">{new Date(u.at).toLocaleString()}</p></div>
              <button onClick={() => remove(i)} className="text-slate-500 hover:text-red-400 shrink-0"><Trash2 size={14} /></button>
            </div>
          ))}
        </div>
      )}
      <textarea data-testid={`order-update-message-${order.orderId}`} className={`${input} h-20 resize-none`} value={msg} onChange={(e) => setMsg(e.target.value)} placeholder="e.g. Your package was delayed by weather and will ship tomorrow." maxLength={1000} />
      <div className="mt-2 flex flex-wrap items-center justify-between gap-3">
        <label className="inline-flex items-center gap-2 text-sm text-slate-300 cursor-pointer"><input type="checkbox" checked={notify} onChange={(e) => setNotify(e.target.checked)} className="accent-[#d4af37] h-4 w-4" /> Email the customer to check it</label>
        <button onClick={post} disabled={busy} data-testid={`order-update-post-${order.orderId}`} className="inline-flex items-center gap-2 bg-gold hover:bg-gold-light text-navy font-semibold px-5 py-2 rounded-xl transition-colors disabled:opacity-60">{busy ? <Loader2 size={15} className="animate-spin" /> : <Megaphone size={15} />} Post Update</button>
      </div>
    </div>
  );
};

export default OrderUpdates;
